import { useStaticQuery, graphql } from 'gatsby';

const useUSPs = () => {
  const { usps } = useStaticQuery(graphql`
    query CoreStrapi4USPs {
      usps: strapiUsps {
        title
        points {
          id
          point
          icon {
            id
            url # for SVG
            ext # for SVG
            height
            width
            name
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: FIXED
                  width: 32
                  quality: 100
                  placeholder: BLURRED
                )
              }
            }
          }
        }
      }
    }
  `);

  return usps || {};
};

export default useUSPs;
